const isTrue = value => value === true || value === 1 || value === '1' || value === 'true'

export const hasPortalPageAccess = project => (
    isTrue(project?.isOwner)
    || isTrue(project?.hasPageAccess)
)

export const canRequestPortalVibeProject = project => (
    isTrue(project?.hasEntryUrl)
    && isTrue(project?.hasPageRoute)
    && !hasPortalPageAccess(project)
)

export const canCopyPageRoutePrompt = project => (
    project?.accessType === 'INTERNAL' && isTrue(project?.isOwner)
)

export const canOpenPortalVibeProject = project => (
    isTrue(project?.hasEntryUrl)
    && isTrue(project?.hasPageRoute)
    && hasPortalPageAccess(project)
)

export const getPortalVibeOpenDisabledReason = project => (
    canOpenPortalVibeProject(project) ? '' : isTrue(project?.hasPageRoute)
        ? isTrue(project?.hasEntryUrl)
            ? '当前用户没有页面访问权限，请先申请访问'
            : '该应用暂无线上入口，暂时不可打开'
        : '该应用仅提供接口服务，暂无可打开的页面'
)
